import Compressor from 'compressorjs'
import Constants from '@/utils/Constants'

export default {
  getImageDimensions(blobOrFile) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = function (e) {
        const img = new Image()
        img.onload = function () {
          resolve({
            width: img.width,
            height: img.height
          })
        }
        img.onerror = reject
        img.src = e.target.result
      }
      reader.onerror = reject
      reader.readAsDataURL(blobOrFile)
    })
  },

  compressImage(file, originalWidth, originalHeight) {
    const imageWidthMax = Constants.MaxUploadImageWidth || 1280
    const imageHeightMax = Constants.MaxUploadImageHeight || 720

    const widthRatio = imageWidthMax / originalWidth
    const heightRatio = imageHeightMax / originalHeight

    let ratio = Math.min(widthRatio, heightRatio)

    if (ratio > 1) ratio = 1

    return new Promise((resolve, reject) => {
      new Compressor(file, {
        width: originalWidth * ratio,
        height: originalHeight * ratio,
        convertSize: Constants.MaxUploadFileSize,
        retainExif: true,
        success: (result) => {
          resolve(this.blobToFile(result, file.name))
        },
        error: (err) => {
          reject(err)
        }
      })
    })
  },

  blobToFile(blob, fileName) {
    return new File([blob], fileName, {
      type: blob.type,
      lastModified: Date.now()
    })
  },

  async getCompressedImage(file) {
    try {
      const array = file.name.split('.')
      const expand = array[array.length - 1].toLowerCase()

      if (['jpeg', 'jpg', 'png', 'webp'].includes(expand)) {
        const {width, height} = await this.getImageDimensions(file)
        return await this.compressImage(file, width, height)
      }
      return file
    } catch (err) {
      console.error('getCompressedImage error:', err)
      return file
    }
  }
}